import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BuildingContactRoleView } from '@api-proxies';
import { BuildingContactRoleService } from '@http/clients/building-contact-role.service';
import { EntityTypes } from '@models/enums/EntityTypes';
import { EditorComponentBase, GenericDropdownComponent } from 'ngx-lib';

@Component({
    selector: 'app-building-contact-role-editor',
    templateUrl: './building-contact-role-editor.component.html',
    styleUrls: ['./building-contact-role-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent]
})
export class BuildingContactRoleEditorComponent extends EditorComponentBase<number | null> implements OnInit {
    buildingContactRoles?: BuildingContactRoleView[];
    selectedRole?: BuildingContactRoleView;

    constructor(private readonly buildingContactRoleService: BuildingContactRoleService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.buildingContactRoles = await this.buildingContactRoleService.getByUsage(EntityTypes.Contact, undefined);
        if (this.bindingProperty)
            this.selectedRole = this.buildingContactRoles?.find((x) => x.id === this.bindingProperty);
    }

    onBuildingContactRoleChange() {
        if (this.selectedRole?.id) {
            this.bindingProperty = this.selectedRole.id;
        } else {
            this.bindingProperty = null;
        }
    }
}
